import React, {useState} from 'react';
import {Flex, Typography} from "antd";
import style from "./ProductDetail.module.scss";
import {StyledTypography} from "./ProductDetail.styled";
import {ProductDescriptionProps} from "../../models";
import Paragraph from 'antd/es/typography/Paragraph';

const ProductDescription = ({product} : ProductDescriptionProps) => {
    const [rows, setRows] = useState(2);
    const [expanded, setExpanded] = useState(false);
    return (
        <Flex vertical>
            <span className={style.productDescriptionTitle}>توضیحات</span>
           <Paragraph>
               {product?.description}
           </Paragraph>
        </Flex>
    );
};

export default ProductDescription;
